import {useReducer, useEffect, useRef, useContext} from 'react';
import {HomePage} from './HomePage';
import {ScenePage} from './ScenePage';
import {StartPage} from './StartPage';
import {CoursePage} from './CoursePage';
import {ContactPage} from './ContactPage';
import {ThankPage} from './ThankPage';
import {Dispatcher} from './Dispatcher';
import {AppContext} from '../App';
import './Page.css';

let autoincrement = 1;

function reduce(state, action)
{
	if(action.type === 'replace')
	{
		return action.data;
	}

	const newState = reduce2(state, action); 
	if(window.sessionStorage)
	{
		let store = Object.assign({}, newState);
		store.pages = store.pages.map((v) =>
		{
			return v.id;
		});

		window.sessionStorage.setItem('state', JSON.stringify(store));
	}
	return newState;
}


function makePage(id, info, args)
{
	let page;
	switch(id)
	{
		case 'scene':
			page = {com: <ScenePage />, oid: 1};
			break;
		case 'start':
			page = {com: <StartPage scene={args.scene} />, oid: 2};
			break;
		case 'course':
			page = {com: <CoursePage courses={info.careers} />, oid: 3};
			break;
		case 'contact':
			page = {com: <ContactPage />, oid: 4};
			break;
		case 'thank':
			page = {com: <ThankPage />, oid: 5};
			break;
		case 'home':
			page = {com: <HomePage />, oid: 0};
			break;
		default:
			throw new Error('Logical error');
	}
	page.id = id;
	page.rid = autoincrement++;
	return page;
}

function reduce2(state, action)
{
	let pages = [...state.pages];
	if(state.action === 'pop' && pages.length > 1)
	{
		pages.pop();
	}

	if((pages[pages.length - 1].id === action.page && action.type === state.action) || (action.type === 'pop' && pages.length === 1))
	{
		//prevent double / triple clicks
		return state;
	}

	let args = state.args ? {...state.args} : {};
	let info = state.userInfo ? {...state.userInfo} : {};
	if (action.type === 'push' || action.type === 'jump')
	{
		let page;
		let args2 = action.args;
		if(args2)
		{
			if(args2.info)
			{
				Object.assign(info, args2.info);
			}	
			Object.assign(args, args2);
			delete args['info'];
		}

		page = makePage(action.page, info, args);
		pages.push(page);
		
		if(!window.history.state || window.history.state.id !== page.id)
		{
			window.history.pushState({id: page.id, args: action.args, oid: page.oid}, '');
		}
	}
	else if(action.type === 'reset')
	{
		pages = [action.page];
	}
	return {action: action.type, pages: pages, userInfo: info, args: args};
}

const emitter = new Dispatcher();

export function Page()
{
	const [state, dispatch] = useReducer(reduce,
		{
			pages: [
				{id: 'home', com: <HomePage />, rid: 0, oid: 0}
			],
			action: null,
			userInfo: null,
			args: null
		}
	);
	const appContext = useContext(AppContext);
	const viewPortRef = useRef(null);
	const currentPageRef = useRef();

	useEffect(() =>
	{
		const div = viewPortRef.current;

		if(state.pages.length > 1)
		{
			let n = div.children.length;
			if(state.action === 'push' || state.action === 'jump')
			{	
				n = n - 1;
			}
			else
			{
				n = n - 2;
			}

			currentPageRef.current = state.pages[n];
			const gtmOp = window.gtmOp || [];
			gtmOp.push({'event': 'page_change', 'page_detail': state.pages[n].id});
			emitter.dispatch('show', {action: state.action, page: state.pages[n]});
			const onTransEnd = (evt) =>
			{
				if(evt.target !== div) return;
				div.classList.remove('is-animating');
				if(state.action === 'jump')
				{
					dispatch({type: 'reset', page: state.pages[state.pages.length - 1]});
					return;
				}
				let m = div.children.length;
				let o;
				let n;
				if(state.action === 'push')
				{ 
					o = m - 2;
					n = m - 1;
				}
				else
				{
					o = m - 1;
					n = m - 2;
				}
				setTimeout(() =>
				{
					document.documentElement.scrollTo({top: 0, behavior: 'smooth'});
				}, 100);

				if(o !== 0 && !div.children[0].classList.contains('is-clipped'))
				{
					//restore from session
					let j = 0;
					let ch;
					for(; j < m; j++)
					{
						if(j === n) continue;
						ch = div.children[j]; 	
						ch.classList.add('is-clipped');
						//FIXME state.action is inconsisitent 
						emitter.dispatch('hide', {action: state.action, page: state.pages[j]});
					}
				}	
				else
				{
					div.children[o].classList.add('is-clipped');
					emitter.dispatch('hide', {action: state.action, page: state.pages[o]});
				}
			};
			div.children[n].classList.remove('is-clipped');
			div.addEventListener('transitionend', onTransEnd);
			if(n)
			{
				div.style.transform = 'translateX(-' + n + '00%)';
			}
			else
			{
				div.style.transform = '';
			}
			// document.documentElement.scrollTop = 0;
			div.classList.add('is-animating');
			return () =>
			{
				div.removeEventListener('transitionend', onTransEnd);
			};
		}
		else
		{
			currentPageRef.current = state.pages[0];
			if(state.action === 'reset')
			{
				div.style.transitionDuration = '0s';
				div.style.transform = '';
				setTimeout(() =>
				{
					div.style.transitionDuration = '';
				}, 100);
                

			}
		}
	}, [state]);

	useEffect(() =>
	{
		const onPopState = (evt) =>
		{
			const pop = evt.state;
			if(!pop || pop.oid < currentPageRef.current.oid)
			{
				dispatch({type: 'pop'});
			}
			else
			{
				dispatch({type: 'push', page: pop.id, args: pop.args});
			}
		};
		window.addEventListener('popstate', onPopState);

		if(window.history.state && window.sessionStorage)
		{
			let store = window.sessionStorage.getItem('state');
			if(store)
			{
				const sess = JSON.parse(store);
				const {userInfo, args} = sess;
				sess.pages = sess.pages.map((id) =>
				{
					return makePage(id, userInfo, args);
				});

				//console.log(sess);
				dispatch({type: 'replace', data: sess});

			}
		}

		return () =>
		{
			window.removeEventListener('popstate', onPopState);
		};

	}, []);

	return (<div className="page-container">
		<div className="view">
			<div className="view-port" ref={viewPortRef}>
				<AppContext.Provider value={{...appContext, dispatch, emitter, userInfo: state.userInfo}} >
				{
					state.pages.map((p) =>
					{
						return (
							<div key={p.rid} className={'page page-' + p.id}>
								{p.com}
							</div>
						);
					})
				}
				</AppContext.Provider>
			</div>
		</div>
	</div>);
}
